import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import CloseButton from '../button/CloseButton';

type SchedulePanelHeaderProps = {
  icon: LucideIcon;
  title: string;
  onClose: () => void;
  actions?: ReactNode;
};

const SchedulePanelHeader = ({
  icon: Icon,
  title,
  onClose,
  actions,
}: SchedulePanelHeaderProps) => {
  return (
    <div className="flex shrink-0 items-center justify-between gap-2 px-5 pt-5 pb-3 border-b border-gray-100">
      <div className="flex items-center gap-2 min-w-0">
        <Icon className="h-5 w-5 shrink-0 text-gray-700" aria-hidden />
        <h3 className="text-base font-bold text-gray-900 truncate">{title}</h3>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {actions}
        <CloseButton
          onClose={onClose}
          className="relative right-auto top-auto shrink-0"
        />
      </div>
    </div>
  );
};

export default SchedulePanelHeader;
